"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paragraph = exports.Image = exports.Link = exports.Iframe = exports.Title = exports.StyledRow = exports.StyledWrapper = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  color: ", ";\n  font-size: ", ";\n  .player-wrapper {\n    position: relative;\n    padding-top: 56.25%; /* 720 / 1280 = 0.5625 */\n  }\n  .react-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"], ["\n  border-radius: ", ";\n  color: ", ";\n  font-size: ", ";\n  .player-wrapper {\n    position: relative;\n    padding-top: 56.25%; /* 720 / 1280 = 0.5625 */\n  }\n  .react-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  align-items: ", ";\n  flex-direction: ", ";\n"], ["\n  align-items: ", ";\n  flex-direction: ", ";\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: ", "px;\n  font-size: ", ";\n"], ["\n  color: ", ";\n  margin-bottom: ", "px;\n  font-size: ", ";\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  width: 100%;\n  height: ", ";\n"], ["\n  border-radius: ", ";\n  width: 100%;\n  height: ", ";\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  padding: 10px 15px;\n  margin-right: 10px;\n  display: inline-block;\n  font-size: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n  border-radius: ", ";\n  color: ", ";\n  transition: all 0.3s ease-in-out;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  padding: 10px 15px;\n  margin-right: 10px;\n  display: inline-block;\n  font-size: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n  border-radius: ", ";\n  color: ", ";\n  transition: all 0.3s ease-in-out;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n    text-decoration: none;\n  }\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  border-radius: ", ";\n"], ["\n  border-radius: ", ";\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globalCss = require("../../../styles/globalCss");

var variable = _interopRequireWildcard(_globalCss);

var _colors = require("../../../styles/colors");

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = exports.StyledWrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.radius;
}, function (props) {
  return props.textColor || {};
}, function (props) {
  return props.textFontSize || variable.baseFont;
});
var StyledRow = exports.StyledRow = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.contentAlign || {};
}, function (props) {
  return props.columnPosition || {};
});
var Title = exports.Title = _styledComponents2.default.h2(_templateObject3, function (props) {
  return props.titleColor || colors.blackColor;
}, function (props) {
  return props.bottomSpace || "20";
}, function (props) {
  return props.titleFontSize || variable.H2;
});

var Iframe = exports.Iframe = _styledComponents2.default.iframe(_templateObject4, function (props) {
  return props.radius || {};
}, function (props) {
  return props.iframeHeight || "350px";
});

var Link = exports.Link = _styledComponents2.default.a(_templateObject5, function (props) {
  return props.fontSize || variable.baseFont;
}, function (props) {
  return props.borderColor || colors.blackColor;
}, function (props) {
  return props.bgColor || {};
}, function (props) {
  return props.buttonRadius || {};
}, function (props) {
  return props.buttonColor || colors.blackColor;
}, function (props) {
  return props.hoverBgColor || {};
}, function (props) {
  return props.buttonHoverColor || colors.blackColor;
}, function (props) {
  return props.hoverBorderColor || {};
});

var Image = exports.Image = _styledComponents2.default.img(_templateObject6, function (props) {
  return props.imageRadius || {};
});
var Paragraph = exports.Paragraph = _styledComponents2.default.div(_templateObject7, function (props) {
  return props.contentSpace || {};
});